import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { CSSResultGroup, LitElement, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { style } from './bypass-button.style.js'


type BypassUrl = {
  name: string,
  url: string
}

@customElement('csc-bypass-button')
export class CSCBypassButton extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @property({ type: Array })
  urls: BypassUrl[] = []

  @property({ type: String })
  variant = 'secondary'

  override render() {
    return html`
      ${this.urls.map(item => html`
        <cse-button url="${item.url}" class="csc-bypass-button">${item.name}</cse-button>
      `)}
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-bypass-button': CSCBypassButton,
  }
}
